import CustomFieldDataType from "@mapmycustomers/shared/enum/CustomFieldDataType";
import EntityType from "@mapmycustomers/shared/enum/EntityType";
import type {
  FiDatasetEntityType,
  FiLimits,
} from "@mapmycustomers/shared/types/entity/fieldInsight";

import { Tone } from "../enums";
import type { AnalysisConfig, DatasetConfig, WordCloudConfig } from "../types";

// Entities whose notes can feed the summary / word cloud, in display order.
export const DATASET_ENTITY_TYPES: FiDatasetEntityType[] = [
  EntityType.ACTIVITY,
  EntityType.COMPANY,
  EntityType.PERSON,
  EntityType.DEAL,
];

// The web app's own floor — the API has no minimum.
export const DATASET_MIN_NOTES_PER_ENTITY = 1;
export const DATASET_DEFAULT_NOTES_PER_ENTITY = 100;
export const DATASET_MIN_EMAILS = 1;
export const DATASET_DEFAULT_EMAILS = 150;
export const SOURCE_LIMIT_LABEL_SPAN = 10;

// What the modal enforces until GET /field-insights/weekly-summary-limits answers, and if it fails.
// These are the API's own values, so a limit change never needs a paired web release.
export const DEFAULT_FI_LIMITS: FiLimits = {
  asyncThreshold: 500,
  customInstructions: { maxLength: 1000 },
  dataPoints: { maxTotal: 5 },
  eligibleCustomFieldTypes: [
    CustomFieldDataType.BOOLEAN,
    CustomFieldDataType.DECIMAL,
    CustomFieldDataType.INTEGER,
    CustomFieldDataType.MONETARY,
    CustomFieldDataType.MULTI_OPTION,
    CustomFieldDataType.SINGLE_OPTION,
  ],
  emails: { maxTotal: 150 },
  notes: { maxPerEntity: 500, maxTotal: 2000 },
  wordCloud: { maxWordListEntries: 40, maxWords: 100 },
};

export const DEFAULT_DATASET_CONFIG: DatasetConfig = {
  entities: DATASET_ENTITY_TYPES.map((entityType) => ({
    entityType,
    noteCount: DATASET_DEFAULT_NOTES_PER_ENTITY,
  })),
};

export const DEFAULT_ANALYSIS_CONFIG: AnalysisConfig = {
  availableFocusAreas: [],
  customInstructions: "",
  dataset: DEFAULT_DATASET_CONFIG,
  focusAreas: [],
  tone: Tone.FORMAL,
};

// Mirrors the API's own default, so an org with no saved settings sees the cap
// the backend will actually apply rather than an empty control.
export const DEFAULT_MAX_WORDS = 40;

export const DEFAULT_WORD_CLOUD_CONFIG: WordCloudConfig = {
  excludedWords: [],
  maxWords: DEFAULT_MAX_WORDS,
  whitelist: [],
};
